import { Language } from "@/constants";
import { Plan } from "./Plan";
import { User } from "./User";

enum RenewalFrequency {
  Month = "month",
  Year = "year",
  Custom = "custom",
}

export enum OrganizationStatus {
  Signup = "signup",
  Trial = "trial",
  AutomaticTrial = "automatic_trial",
  MailOnlyTrial = "mail_only_trial",
  Paying = "paying",
  Free = "free",
  VIP = "vip",
  Expired = "expired",
  AutomaticTrialExpired = "automatic_trial_expired",
  Churned = "churned",
  Unknown = "unknown",
}

export type Organization = {
  id?: string;
  name: string;
  uuid: string;
  status: OrganizationStatus;
  has_reached_num_alert_limit: boolean;
  languages: Language[];
  is_from_growth_app: boolean;
  users: User[];
  allow_sso_login_only: boolean;

  plan: Plan;

  plan_subscriptions: Array<{
    end_date: number;
    renewal_frequency: RenewalFrequency;
  }>;
};

export type OrganizationLight = Pick<
  Organization,
  "id" | "uuid" | "name" | "status"
>;
